module.exports = __webpack_public_path__ + "img/ruoyi4.280ee069.png";